import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "End User Licence Agreement")
], -1)
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "eulaText",
  class: "eulaText"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_submit = _resolveComponent("v-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_v_input, {
          title: "Type 'Agree' to accept",
          type: "text",
          value: _ctx.agreement,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.agreement = $event)),
          error: _ctx.error('b_eula'),
          placeholder: "Agree"
        }, null, 8, ["value", "error"]),
        _createVNode(_component_v_submit, {
          loading: _ctx.loading('signUp_Eula'),
          submitTitle: "Agree",
          cancelTitle: "Cancel",
          onSubmit: _ctx.signUp_Eula,
          onCancel: _ctx.cancel
        }, null, 8, ["loading", "onSubmit", "onCancel"])
      ])
    ])
  ]))
}